import { render, staticRenderFns } from "./Coefficient.vue?vue&type=template&id=8518b9fe&scoped=true&lang=pug&"
import script from "./Coefficient.vue?vue&type=script&setup=true&lang=js&"
export * from "./Coefficient.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Coefficient.vue?vue&type=style&index=0&id=8518b9fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8518b9fe",
  null
  
)

export default component.exports